// BUSINESS LINES
export const CREATE_BUSINESS_LINE = 'CREATE_BUSINESS_LINE';
export const CREATE_BUSINESS_LINE_SUCCESS = 'CREATE_BUSINESS_LINE_SUCCESS';
export const CREATE_BUSINESS_LINE_ERROR = 'CREATE_BUSINESS_LINE_ERROR';
export const DELETE_BUSINESS_LINE = 'DELETE_BUSINESS_LINE';
export const DELETE_BUSINESS_LINE_SUCCESS = 'DELETE_BUSINESS_LINE_SUCCESS';
export const DELETE_BUSINESS_LINE_ERROR = 'DELETE_BUSINESS_LINE_ERROR';
export const HIDE_DELETE_BUSINESS_LINE_ERROR = 'HIDE_DELETE_BUSINESS_LINE_ERROR';
